export default __webpack_public_path__ + "static/media/copy-grey.c1d01044.svg";